import React from 'react';
import '../styles/Hero.css';
import heroImage from '../assets/hero-bg.jpg';

const Hero = () => {
  return (
    <div className="hero" style={{ backgroundImage: `url(${heroImage})` }}>
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <h1>Professional,<br />Quality Cleaning.</h1>
        <p>We are professional cleaners in Durham,<br />Toronto, and the GTA, offering High-Quality<br />Cleaning Services.</p>
        <button className="cta-button">Book A Clean</button>
      </div>
    </div>
  );
};

export default Hero; 